import { SwApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import { writable } from "svelte/store";
import { getUploadsNotifications } from "../../../../api/uploads-notifications";

export const uploadsModalStore = writable(false);
export const persistedFilesStore = writable([]);
export const selectedProjectIdsStore = writable([]);
export const activeTabStore = writable("uploads"); // "recents" or "uploads"

export const createIsDraggingFilesStore = () => {
  const { subscribe, set } = writable(false);

  return {
    subscribe,
    set: (value) => {
      if (value) {
        activeTabStore.set("uploads");
      }
      set(value);
    },
  };
};

export const isDraggingFilesStore = createIsDraggingFilesStore();

export const uploadsNotificationsStore = SwApiStore({
  get: getUploadsNotifications,
  init: () => ({ notifications: [] }),
  onMessage: ({ message, get }) => {
    if (message.kind !== "update-uploads-notifications") return;
    get();
  },
  cacheKey: "uploads-notifications",
});
